import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import { AppRoutes } from "./router";
import { queryClient } from "./api/queryClient";
import { AuthProvider } from "./auth/AuthContext";
import { ToastProvider } from "./components/ui/Toast";
import { ErrorBoundary } from "./components/ErrorBoundary";
import OfflineBanner from "./components/OfflineBanner";
import { useAndroidBackButton } from "./native/useAndroidBackButton";

function App() {
  // 安卓 App 内接管实体返回键；网页端是空操作
  useAndroidBackButton();

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <AuthProvider>
            <BrowserRouter basename={__BASE_PATH__}>
              <OfflineBanner />
              <AppRoutes />
            </BrowserRouter>
          </AuthProvider>
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
